'use client';

import { getCookie } from 'cookies-next';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

import { useClientCapabilities } from './use-client-capabilities';

/**
 * Checks if current request is a webview request.
 * Returns undefined while the webview state enumeration is not ready.
 */
export const useIsWebviewRequest = (): boolean | undefined => {
  const [isWebviewRequest, setIsWebviewRequest] = useState<boolean>();
  const params = useSearchParams();
  const clientIdentifier = useClientCapabilities();

  const byClient = clientIdentifier.isWebViewCapable();

  const queryValue = params?.get('webview');
  const hasWebviewInQuery = queryValue === '1' || queryValue === 'true';

  // TODO: Centralize `webview` cookie name -- See `COOKIE_NAME_WEBVIEW`.
  const cookieValue = getCookie('webview');
  const hasWebviewInCookie =
    cookieValue === '1' || cookieValue === 'true' || cookieValue === true;

  const win = typeof window !== 'undefined' ? window : null;

  useEffect(() => {
    if (typeof isWebviewRequest !== 'undefined' || win === null) {
      return;
    }

    setIsWebviewRequest(byClient || hasWebviewInQuery || hasWebviewInCookie);
  }, [win, byClient, hasWebviewInQuery, isWebviewRequest, hasWebviewInCookie]);

  if (clientIdentifier.isWebViewCapable()) {
    return true;
  }

  return isWebviewRequest;
};
